<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Source content</h3>
  </div>

  <div class="modal-content">
    <form class="form-field-full" [formGroup]="contentForm">
      <mat-form-field class="gingr-input-wrapper w-full">
        <textarea matInput formControlName="content"></textarea>
      </mat-form-field>
      <div class="d-flex justify-content-center">
        @if (isLoading) {
          <mat-progress-spinner
            class="spinner"
            [color]="'accent'"
            [mode]="'indeterminate'"
            [value]="50"
            >
          </mat-progress-spinner>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      mat-raised-button
      color="accent"
      [disabled]="contentForm.invalid || isLoading"
      (click)="saveContent()"
      >
      Save content
    </button>
    <button mat-button (click)="close()" [disabled]="isLoading">Close</button>
  </div>
</div>
